<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="NAVOnlineInvoiceInterfaceSettings"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
      :readonly="resource.locked"
      :labelAlign="$config.forms.defaultLabelAlign"
      :id="formId"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpRow>
        <ItpCol>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="company_name"
            :label="'Company name'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            required
          >
            <b-form-input
              plaintext
              v-model="editor.company_name"
              class="font-weight-bold no-focus-border"
            >
            </b-form-input>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="base_url"
            :label="'Base URL'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            :helpTooltip="'The root URL of the service.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            required
          >
            <ItpFormInput
              name="base_url"
              v-model="editor.base_url"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="tax_number"
            :label="'Tax number'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            required
            :helpTooltip="'The first 8 digits of the tax number.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
          >
            <ItpFormInput
              name="tax_number"
              v-model="editor.tax_number"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="login"
            :label="'Login'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            :helpTooltip="'The technical user\'s login name.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            required
          >
            <ItpFormInput
              name="login"
              v-model="editor.login"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <HR>
          </HR>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="password_hash"
            :label="'Password hash'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            :helpTooltip="'The generated password\'s SHA-512 hash.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
          >
            <ItpFormTextarea
              name="password_hash"
              v-model="resource.password"
              readonly
            >
            </ItpFormTextarea>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="password"
            :label="'Password'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            :helpTooltip="'The generated password.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
          >
            <ItpFormInput
              type="password"
              name="password"
              v-model="change_password.password"
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="password"
            :label="'Confirm password'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            :helpTooltip="'The generated password.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
          >
            <ItpFormInput
              type="password"
              name="verify_password"
              v-model="change_password.verify_password"
            >
            </ItpFormInput>
          </ItpFormGroup>
          <HR>
          </HR>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="xml_sign_key"
            :label="'XML sign key'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            :helpTooltip="'The technical user\'s XML sign key.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            required
          >
            <ItpFormInput
              name="xml_sign_key"
              v-model="editor.xml_sign_key"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="exchange_key"
            :label="'XML exchange key'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            :helpTooltip="'The technical user\'s XML exchange key.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            required
          >
            <ItpFormInput
              name="exchange_key"
              v-model="editor.exchange_key"
              required
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="add_unknown_clients"
            :label="'Save unknown clients.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            :helpTooltip="'Add unknown client to the database.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
          >
            <ItpFormCheckbox
              name="add_unknown_clients"
              v-model="editor.add_unknown_clients"
            >
            </ItpFormCheckbox>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="2"
            name="lookback_period"
            :label="'Lookback period'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            :helpTooltip="'The number of days to be used to look back for invoices.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            contentClass="input-group"
          >
            <ItpFormInput
              type="number"
              name="lookback_period"
              v-model="editor.lookback_period"
            >
            </ItpFormInput>
            <DIV
              class="input-group-append"
            >
              <span
                class="input-group-text"
              >
                {{ 'days'|pgettext('InputGroupAddon') }}
              </span>
            </DIV>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="2"
            name="request_timeout"
            :label="'Request timeout'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            :helpTooltip="'Stop waiting for a response once the specified timeout has expired.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            contentClass="input-group"
          >
            <ItpFormInput
              type="number"
              name="request_timeout"
              v-model="editor.request_timeout"
            >
            </ItpFormInput>
            <DIV
              class="input-group-append"
            >
              <span
                class="input-group-text"
              >
                sec
              </span>
            </DIV>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="auto_sync"
            :label="'Auto sync'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            :helpTooltip="'Check to include this company to the automated sync job.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
          >
            <ItpFormCheckbox
              name="auto_sync"
              v-model="editor.auto_sync"
            >
            </ItpFormCheckbox>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="pull_incoming_invoices"
            :label="'Pull incoming invoices'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            :helpTooltip="'Enable pulling of incoming invoices from the agency.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
          >
            <ItpFormCheckbox
              name="pull_incoming_invoices"
              v-model="editor.pull_incoming_invoices"
            >
            </ItpFormCheckbox>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="pull_outgoing_invoices"
            :label="'Pull outgoing invoices'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            :helpTooltip="'Enable pulling of outgoing invoices from the agency.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
          >
            <ItpFormCheckbox
              name="pull_outgoing_invoices"
              v-model="editor.pull_outgoing_invoices"
            >
            </ItpFormCheckbox>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
            name="invoice_tag"
            :label="'Invoice tag'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
            :helpTooltip="'The tag to set on the imported invoices.'|pgettext('NAVOnlineInvoiceInterfaceSettings')"
          >
            <ItpFormInput
              name="invoice_tag"
              v-model="editor.invoice_tag"
            >
            </ItpFormInput>
          </ItpFormGroup>
        </ItpCol>
      </ItpRow>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="forms[formName] && forms[formName].id"
      :text="'Save'|pgettext('Button')"
      type="submit"
      variant="primary"
      default
      :spinning="actions.submit && actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|pgettext('Button')"
      variant="default"
      :disabled="actions.submit && actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class NAVOnlineInvoiceInterfaceSettings extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: String,
  })
  companyId!: string;

  @Watch('companyId')
  onCompany_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("companyId")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  resource!: any;

  async $$load_resource() {
    return this.$fn.fetch('read_nav_online_interface_setting', { parameters: { company_id: this.companyId }, asResource: true })
  }

  editor!: any;

  async $$load_editor() {
    return this.resource.editor()
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  change_password!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['resource', 'editor', 'formId', 'formName', 'change_password', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        resource: null,
        editor: null,
        formId: null,
        formName: "NAVOnlineInvoiceInterfaceSettings",
        change_password: {
          password: null,
          verify_password: null,
        }
        ,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get payload() {
    if (this.loaded) {

      return _.extend(
        {},
        this.editor.getData(),
        this.change_password.password && this.change_password.verify_password ? this.change_password : null
      )
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.$fn.pgettext("NAVOnlineInvoiceInterfaceSettings|Title", "NAV online invoice interface configuration")
          ,
        this.resource.company_name
          ,
        ]
        ,
        icon: this.$config.settings.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_5044_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5044, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_script_5050_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1040167445267876_script_5050, alias=undefined
    this.resource.reset($event.data.response.data)
  }

  async act_1040167445267876_script_5050_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1040167445267876_script_5050, alias=undefined
    return {
      value: () => this.act_1040167445267876_script_5050_getActionArgs_value($event),
    }
  }

  async evh_1040167445267876_success_5049_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_success_5049, alias=undefined
    return !!$event.data.response.data
  }

  async act_1040167445267876_emit_5052_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1040167445267876_emit_5052, alias=undefined
    return {
      event: "saved",
    }
  }

  async evh_1040167445267876_success_5051_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_success_5051, alias=undefined
    return !!$event.data.response.data
  }

  async act_1040167445267876_request_5048_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_5048, alias=submit
    return {
      operation: "update_nav_online_interface_setting",
      data: this.payload,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_5054_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_5054, alias=undefined
    return {
      name: this.modalName,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5044: actions.CloseModalAction;
    evh_7315092382398562_close_5043: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_5046: actions.CloseComponentAction;
    evh_2248226175642056_close_5045: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_script_5050: actions.ScriptAction;
    evh_1040167445267876_success_5049: actions.EventHandlerImpl;
    act_1040167445267876_emit_5052: actions.EmitAction;
    evh_1040167445267876_success_5051: actions.EventHandlerImpl;
    act_1040167445267876_request_5048: actions.RequestAction;
    evh_1040167445267876_submit_5047: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_5054: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_5053: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5044 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5044_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5043 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5044,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5043],
      }
    );
    const act_2248226175642056_closeComponent_5046 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_5045 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_5046,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_5045],
      }
    );
    const act_1040167445267876_script_5050 = new actions.ScriptAction(
      {
        actionArgs: this.act_1040167445267876_script_5050_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_5049 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_script_5050,
        event: "success",
        when: this.evh_1040167445267876_success_5049_getWhen,
        displayName: "script",
      }
    );
    const act_1040167445267876_emit_5052 = new actions.EmitAction(
      {
        actionArgs: this.act_1040167445267876_emit_5052_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_5051 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_emit_5052,
        event: "success",
        when: this.evh_1040167445267876_success_5051_getWhen,
        displayName: "emit",
      }
    );
    const act_1040167445267876_request_5048 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_5048_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_success_5049, evh_1040167445267876_success_5051],
      }
    );
    const evh_1040167445267876_submit_5047 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_5048,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_5047],
      }
    );
    const act_1419464017721962_closeModal_5054 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_5054_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_5053 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_5054,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_5053],
      }
    );
    return {
      act_7315092382398562_closeModal_5044,
      evh_7315092382398562_close_5043,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_5046,
      evh_2248226175642056_close_5045,
      evh_2248226175642056_close,
      act_1040167445267876_script_5050,
      evh_1040167445267876_success_5049,
      act_1040167445267876_emit_5052,
      evh_1040167445267876_success_5051,
      act_1040167445267876_request_5048,
      evh_1040167445267876_submit_5047,
      evh_1040167445267876_submit,
      act_1419464017721962_closeModal_5054,
      evh_1419464017721962_clickPreventStop_5053,
      evh_1419464017721962_clickPreventStop,
      submit: act_1040167445267876_request_5048,
    }
  }
}

Vue.component("NAVOnlineInvoiceInterfaceSettings", NAVOnlineInvoiceInterfaceSettings);

</script>